<template>
  <div class="finance-more">
    <!-- 补齐资料、增加费用、移交 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
      @open="init"
      @submit.native.prevent="confirm('ruleMoreForm')"
    >
      <el-form
        :model="ruleMoreForm"
        :rules="rules"
        ref="ruleMoreForm"
        class="demo-ruleMoreForm"
      >
        <el-form-item v-if="type == 1" label="备注" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="ruleMoreForm.remarks"
            maxlength="50"
            show-word-limit
            resize="none"
            rows="3"
          />
        </el-form-item>
        <el-form-item v-if="type == 2" label="选择移交人员" prop="transferor">
          <el-select v-model="ruleMoreForm.transferor" placeholder="请选择">
            <el-option
              v-for="item in financeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="type == 3">
          <el-form-item label="费用类型" prop="costType">
            <el-select
              v-model="ruleMoreForm.costType"
              placeholder="请选择"
              @change="changeCostType"
            >
              <el-option
                v-for="item in costTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人数" prop="peopleNums">
            <el-input
              class="gray white"
              v-model="ruleMoreForm.peopleNums"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="天数" prop="days">
            <el-input
              class="gray white"
              v-model="ruleMoreForm.days"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="标准（人/天）" prop="standard">
            <el-input
              class="gray white"
              v-model="ruleMoreForm.standard"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="金额" prop="amount">
            <el-input
              class="gray white"
              v-model="ruleMoreForm.amount"
              disabled
              placeholder="系统自动计算"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="type == 4" label="单据张数" prop="billNums">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.billNums"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 5" label="银行存款" prop="bankAmount">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.bankAmount"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 6" label="经费类型" prop="reimbursementTypeDesc">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="ruleMoreForm.reimbursementTypeDesc"
            maxlength="50"
            show-word-limit
            resize="none"
            rows="3"
          />
        </el-form-item>
        <el-form-item v-if="type == 7" label="核准金额" prop="approvedAmount">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.approvedAmount"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 8" label="出差天数" prop="dateNums">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.dateNums"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 9" label="出行方式" prop="travelMode">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.travelMode"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 10" label="同行人数" prop="peopleNum">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.peopleNum"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 11" label="到达地点" prop="address">
          <el-input
            class="gray white"
            v-model="ruleMoreForm.address"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 12" label="出差事由" prop="reasonsForBusinessTrip">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="ruleMoreForm.reasonsForBusinessTrip"
            maxlength="50"
            show-word-limit
            resize="none"
            rows="3"
          />
        </el-form-item>
        <el-form-item v-if="type == 13" label="出差日期" prop="date">
          <el-date-picker
            v-model="ruleMoreForm.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="type == 14" label="开支内容" prop="content">
          <el-input
              maxlength="250"
              class="gray white"
              v-model="ruleMoreForm.content"
              placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('ruleMoreForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FinanceApproval from "@/models/finance-approval.js";
import { handleAmount } from "@/common/js/utils.js";
export default {
  props: ['title', 'type', 'dialogVisible', 'teamId', 'deptId', 'approvedAmount',
  'bankAmount', 'financeMoreData', 'reimbursementTypeDesc', 'billNum', 'dateNums',
  'travelMode', 'peopleNum', 'address', 'reasonsForBusinessTrip', 'startTime', 'finishTime',
   'id', 'content'],

  data() {
    return {
      ruleMoreForm: {
        remarks: "",
        transferor: "",
        costType: 15,
        peopleNums: "",
        days: "",
        standard: 80,
        amount: "",
        billNums: '',
        bankAmount: 0,
        reimbursementTypeDesc: '',
        approvedAmount: '',
        dateNums: '',
        travelMode: '',
        peopleNum: '',
        address: '',
        reasonsForBusinessTrip: '',
        date: '',
        content: "",//开始内容
      },
      rules: {
        transferor: [
          { required: true, message: "请选择移交人员", trigger: "change" },
        ],
        costType: [
          { required: true, message: "请选择费用类型", trigger: "change" },
        ],
        peopleNums: [
          { required: true, message: "请输入人数", trigger: "blur" },
        ],
        days: [{ required: true, message: "请输入天数", trigger: "blur" }],
        bankAmount: [{ required: true, message: "请输入银行存款", trigger: "blur" }],
        reimbursementTypeDesc: [{ required: true, message: "请输入经费类型", trigger: "blur" }],
        reasonsForBusinessTrip: [{ required: true, message: "请输入出差事由", trigger: "blur" }],
        date: [{ required: true, message: "请输入出差日期", trigger: "change" }],
      },
      financeList: [],
      costTypeList: [
        { id: 25, name: "交通补助", standard: 80 },
        { id: 26, name: "伙食补助", standard: 100 },
      ],
    }
  },

  watch: {
    "ruleMoreForm.peopleNums": {
      handler: function (newVal, oldVal) {
        if (this.ruleMoreForm.peopleNums && this.ruleMoreForm.days) {
          this.ruleMoreForm.amount =
            (Number(this.ruleMoreForm.peopleNums) *
              Number(this.ruleMoreForm.days) *
              Number(this.ruleMoreForm.standard) *
              100) /
            100;
        }
      },
      deep: true,
      immediate: true,
    },
    "ruleMoreForm.days": {
      handler: function (newVal, oldVal) {
        if (this.ruleMoreForm.peopleNums && this.ruleMoreForm.days) {
          this.ruleMoreForm.amount =
            (Number(this.ruleMoreForm.peopleNums) *
              Number(this.ruleMoreForm.days) *
              Number(this.ruleMoreForm.standard) *
              100) /
            100;
        }
      },
      deep: true,
      immediate: true,
    },
    "ruleMoreForm.standard": {
      handler: function (newVal, oldVal) {
        if (this.ruleMoreForm.peopleNums && this.ruleMoreForm.days) {
          this.ruleMoreForm.amount =
            (Number(this.ruleMoreForm.peopleNums) *
              Number(this.ruleMoreForm.days) *
              Number(this.ruleMoreForm.standard) *
              100) /
            100;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {

  },

  methods: {
    init() {
      this.$nextTick(() => {
        if (this.type == 2) this.initFinanceList()
        if (this.type == 4) this.ruleMoreForm.billNums = this.billNum
        if (this.type == 5) this.ruleMoreForm.bankAmount = this.bankAmount
        if (this.type == 6) this.ruleMoreForm.reimbursementTypeDesc = this.reimbursementTypeDesc
        if (this.type == 7) this.ruleMoreForm.approvedAmount = this.approvedAmount
        if (this.type == 8) this.ruleMoreForm.dateNums = this.dateNums
        if (this.type == 9) this.ruleMoreForm.travelMode = this.travelMode
        if (this.type == 10) this.ruleMoreForm.peopleNum = this.peopleNum
        if (this.type == 11) this.ruleMoreForm.address = this.address
        if (this.type == 12) this.ruleMoreForm.reasonsForBusinessTrip = this.reasonsForBusinessTrip
        if (this.type == 13) this.ruleMoreForm.date = [this.startTime, this.finishTime]
        if (this.type == 14) this.ruleMoreForm.content = this.content;
      })
    },
    /* 财务人员集合 */
    initFinanceList() {
      let searchFlag = 1
      let roleType = 3
      let deptId = this.deptId
      let teamId = this.teamId
      let data = {
        searchFlag,
        roleType,
        teamId,
        deptId
      }
      FinanceApproval.financeList(data).then((res) => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.userId
            obj.name = i.userName
            arr.push(obj)
          })
          this.financeList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    changeCostType(v) {
      let obj = this.costTypeList.find((e) => {
        return e.id == v;
      });
      this.ruleMoreForm.standard = obj.standard;
    },

    handleClose() {
      this.$refs['ruleMoreForm'].resetFields();
      this.ruleMoreForm.remarks = "";
      this.ruleMoreForm.transferor = "";
      this.ruleMoreForm.costType = 15;
      this.ruleMoreForm.peopleNums = "";
      this.ruleMoreForm.days = "";
      this.ruleMoreForm.standard = 80;
      this.ruleMoreForm.amount = "";
      this.ruleMoreForm.billNums = "";
      this.ruleMoreForm.bankAmount = 0;
      this.ruleMoreForm.reimbursementTypeDesc = "";
      this.ruleMoreForm.approvedAmount = "";
      this.ruleMoreForm.dateNums = "";
      this.ruleMoreForm.travelMode = "";
      this.ruleMoreForm.peopleNum = "";
      this.ruleMoreForm.address = "";
      this.ruleMoreForm.reasonsForBusinessTrip = "";
      this.ruleMoreForm.date = "";
      this.$emit('handleClose')
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 1) this._postSupplementData()
          if (this.type == 2) this._postTransferReviewer()
          if (this.type == 3) {
            this.$emit('addCost', this.ruleMoreForm)
            this.handleClose()
          }
          if (this.type == 4) this._postModBillNums()
          if (this.type == 5) {
            this.$emit('getBankAmount', this.ruleMoreForm.bankAmount)
            this.handleClose()
          }
          if (this.type == 6) {
            this.$emit('getReimbursementTypeDesc', this.ruleMoreForm.reimbursementTypeDesc)
            this.handleClose()
          }
          if (this.type == 7) this._postModApprovedAmount()
          if (this.type == 8) this._postModDays()
          if (this.type == 9) this._postModTravelMode()
          if (this.type == 10) this._postModPeopleNum()
          if (this.type == 11) this._postModAddress()
          if (this.type == 12) this._postModReasonsForBusinessTrip()
          if (this.type == 13) this._postModDate()
          if (this.type == 14) this._postModContent()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 补齐资料 */
    _postSupplementData() {
      let data = this.financeMoreData
      data.remark = this.ruleMoreForm.remarks
      FinanceApproval.postSupplementData(data).then((res) => {
        if (res.success) {
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 移交审核人 */
    _postTransferReviewer() {
      let data = this.financeMoreData
      data.transferUserId = this.ruleMoreForm.transferor
      FinanceApproval.postTransferReviewer(data).then((res) => {
        if (res.success) {
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改单据数量 */
    _postModBillNums() {
      let data = this.financeMoreData
      data.billNum = this.ruleMoreForm.billNums
      FinanceApproval.postModBillNums(data).then((res) => {
        if (res.success) {
          this.$emit('getModBillNums',this.ruleMoreForm.billNums)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改核准金额 */
    _postModApprovedAmount() {
      let data = this.financeMoreData
      data.approvedAmount = handleAmount(this.ruleMoreForm.approvedAmount,1)
      if (data.billId) {
        FinanceApproval.postModApprovedAmount(data).then((res) => {
          if (res.success) {
            this.$emit('getApprovedAmount',this.ruleMoreForm.approvedAmount)
            this.handleClose()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        this.$emit('getApprovedAmount',this.ruleMoreForm.approvedAmount)
        this.handleClose()
      }
    },

    /* 修改开支内容 */
    _postModContent() {
      let data = this.financeMoreData
      data.content = this.ruleMoreForm.content;
      if (data.billId) {
        FinanceApproval.postModApprovedContent(data).then((res) => {
          if (res.success) {
            this.$emit('getApprovedContent',this.ruleMoreForm.content)
            this.handleClose()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        this.$emit('getApprovedContent',this.ruleMoreForm.content)
        this.handleClose()
      }
    },

    /* 修改出差天数 */
    _postModDays() {
      let data = {}
      data.days = this.ruleMoreForm.dateNums
      data.id = this.id
      FinanceApproval.postModDays(data).then((res) => {
        if (res.success) {
          this.$emit('getModDays',this.ruleMoreForm.dateNums)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改出行方式 */
    _postModTravelMode() {
      let data = {}
      data.travelMode = this.ruleMoreForm.travelMode
      data.id = this.id
      FinanceApproval.postModTravelMode(data).then((res) => {
        if (res.success) {
          this.$emit('getModTravelMode',this.ruleMoreForm.travelMode)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改同行人数 */
    _postModPeopleNum() {
      let data = {}
      data.peopleNum = this.ruleMoreForm.peopleNum
      data.id = this.id
      FinanceApproval.postModPeopleNum(data).then((res) => {
        if (res.success) {
          this.$emit('getModPeopleNum',this.ruleMoreForm.peopleNum)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改到达地点 */
    _postModAddress() {
      let data = {}
      data.city = this.ruleMoreForm.address
      data.id = this.id
      FinanceApproval.postModAddress(data).then((res) => {
        if (res.success) {
          this.$emit('getModAddress',this.ruleMoreForm.address)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改出差事由 */
    _postModReasonsForBusinessTrip() {
      let data = {}
      data.reasonsForBusinessTrip = this.ruleMoreForm.reasonsForBusinessTrip
      data.id = this.id
      FinanceApproval.postModReasonsForBusinessTrip(data).then((res) => {
        if (res.success) {
          this.$emit('getModReasonsForBusinessTrip',this.ruleMoreForm.reasonsForBusinessTrip)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改出差日期 */
    _postModDate() {
      let data = {}
      data.beginTime = this.ruleMoreForm.date[0]
      data.endTime = this.ruleMoreForm.date[1]
      data.id = this.id
      FinanceApproval.postModDate(data).then((res) => {
        if (res.success) {
          this.$emit('getModDate',this.ruleMoreForm.date)
          this.handleClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  }
}
</script>

<style lang='scss'>
.finance-more {
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-dialog {
    .el-form-item__label {
      line-height: 24px;
    }
    .el-range-editor.el-input__inner {
      width: 100%;
    }
  }
}
</style>
